export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const SET_GRADE = "SET_GRADE";
export const SET_EMAIL = "SET_EMAIL";
export const SET_OFFER_DATA = "SET_OFFER_DATA";
export const SET_VARIANT = "SET_VARIANT";
export const SET_SETTINGS = "SET_SETTINGS";
export const SET_SHOW_GRADE_SELECTION_POPUP = "SET_GRADE_SELECTION_POPUP";
export const SET_SHOW_MORE_PLANS = "SET_SHOW_MORE_PLANS";
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_PROMO_CODE = 'SET_PROMO_CODE';
export const SET_COUPONS = 'SET_COUPONS'